import { TagTypes } from '../../../Api/Types/tagTypes';
import { markCrossFeatureCacheStale } from '../../../App/CrossFeature/crossFeatureCacheBridgeActions';
import type { CreateBookingSimplifiedCostRequest } from '../Types/bookingSimplifiedCost.types';
import { mapCreateBookingSimplifiedCostRequest } from './bookingSimplifiedCostMapper';

export interface CreateBookingSimplifiedCostMutationArgs {
  bookingId: number;
  data: CreateBookingSimplifiedCostRequest;
  idempotencyKey: string;
}

export const buildCreateBookingSimplifiedCostRequest = ({
  bookingId,
  data,
  idempotencyKey,
}: CreateBookingSimplifiedCostMutationArgs) => ({
  url: `/bookings/${bookingId}/simplified-cost`,
  method: 'POST' as const,
  headers: {
    'Idempotency-Key': idempotencyKey,
  },
  body: mapCreateBookingSimplifiedCostRequest(data),
});

export const getCreateBookingSimplifiedCostInvalidatesTags = (bookingId: number) => [
  { type: TagTypes.Booking, id: bookingId },
  { type: TagTypes.Booking, id: TagTypes.List },
];

interface BookingSimplifiedCostMutationLifecycleContext {
  dispatch: (action: unknown) => unknown;
  queryFulfilled: Promise<unknown>;
}

export const handleCreateBookingSimplifiedCostQueryLifecycle = async (
  bookingId: number,
  { dispatch, queryFulfilled }: BookingSimplifiedCostMutationLifecycleContext
): Promise<void> => {
  try {
    await queryFulfilled;
    dispatch(
      markCrossFeatureCacheStale({
        domain: 'expenseInvoices',
        scope: 'list',
        source: 'bookingSimplifiedCostQuickCreate',
        bookingId,
      })
    );
  } catch {
    // Keep cross-slice invalidation success-only to avoid stale state after failed create.
  }
};
